var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectedDashboardDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.966 4.86768L16 11.8341C13.6781 9.51298 11.3554 7.18958 9.03313 4.86768C6.34666 2.18121 2.18245 6.34692 4.86667 9.03414C7.18932 11.3545 9.51272 13.6783 11.8328 16.0002C9.51166 18.3232 7.18963 20.6452 4.86667 22.9663C2.18245 25.652 6.34704 29.8166 9.03313 27.1328C11.355 24.8101 13.6777 22.4871 15.9996 20.1659L22.9657 27.1328C25.6521 29.8185 29.8175 25.6524 27.1321 22.9663C24.8095 20.6437 22.4876 18.3217 20.1642 15.9995C22.4872 13.6768 24.8091 11.3542 27.1321 9.03189C29.8178 6.34692 25.6525 2.18121 22.9657 4.86917",
    fill: "#2D5063"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedDashboardDark);
export default __webpack_public_path__ + "static/media/rejected-dashboard-dark.b9596430e896abceccb3440bc2832fed.svg";
export { ForwardRef as ReactComponent };